export default __webpack_public_path__ + "static/media/beef.4963f9ed.png";